import React from "react";
import { ArrowLeft, Crown, Check, ChevronRight, Zap, Bot } from "lucide-react";

type PlanManagementViewProps = {
  currentPlanDetails: {
    name: string;
    price: string;
    originalPrice?: string;
    features: string[];
    isPremium?: boolean;
  };
  onBack: () => void;
  onManagePlan: () => void;
  onGoToBilling: () => void;
};

const PlanManagementView: React.FC<PlanManagementViewProps> = ({
  currentPlanDetails,
  onBack,
  onManagePlan,
  onGoToBilling,
}) => {
  return (
    <div className="profile-view">
      {/* Header */}
      <header className="profile-header">
        <button
          type="button"
          className="back-btn"
          onClick={onBack}
          aria-label="Back to Profile"
        >
          <ArrowLeft size={24} />
        </button>
        <div className="header-content">
          <span className="header-icon">
            <Crown size={24} />
          </span>
          <h1 className="header-title">Plan Management</h1>
        </div>
        <div className="header-actions"></div>
      </header>

      <div className="profile-content">
        {/* Current Plan Section */}
        <section className="plan-management-section">
          <h2 className="section-title">Your Current Plan</h2>

          <div className="current-plan-card">
            <div className="current-plan-header">
              <div className={`current-plan-icon ${currentPlanDetails.isPremium ? 'premium' : 'basic'}`}>
                {currentPlanDetails.isPremium ? <Zap size={20} /> : <Bot size={20} />}
              </div>
              <div className="current-plan-info">
                <span className="current-plan-name">
                  {currentPlanDetails.name}
                </span>
                <span className="current-plan-price">
                  {currentPlanDetails.price}
                  {currentPlanDetails.originalPrice && (
                    <span className="original-price">
                      {currentPlanDetails.originalPrice}
                    </span>
                  )}
                </span>
              </div>
              <span className={`plan-status-badge ${currentPlanDetails.isPremium ? 'premium' : 'basic'}`}>
                Active
              </span>
            </div>
            <ul className="current-plan-features">
              {currentPlanDetails.features.map((feature, index) => (
                <li key={index}>
                  <Check size={14} />
                  {feature}
                </li>
              ))}
            </ul>
            <div className="current-plan-actions">
              <button
                type="button"
                className="manage-plan-action-btn"
                onClick={onManagePlan}
              >
                <span>View Plans</span>
                <ChevronRight size={18} />
              </button>
            </div>
          </div>
        </section>

        {/* Billing Section */}
        <section className="billing-section">
          <h2 className="section-title">Billing</h2>
          <p className="billing-info">
            Manage your subscription, payment methods, and invoices through our secure billing portal.
          </p>

          <button
            type="button"
            className="subscription-btn secondary"
            onClick={onGoToBilling}
          >
            Go to Billing Portal
          </button>

          <div style={{ display: 'none' }}>
            {/* Payment Details - Commented out as requested */}
            {/* 
            <div className="subscription-card">
              <div className="subscription-card-header">
                <div className="subscription-card-icon">
                  <CreditCard size={20} />
                </div>
                <h3>Payment details</h3>
              </div>
              <p className="subscription-description">
                Update the payment method and billing address.
              </p>
              <div className="subscription-actions">
                <button
                  type="button"
                  className="subscription-btn secondary"
                  onClick={onGoToBilling}
                >
                  Update payment
                </button>
              </div>
            </div>
            */}

            {/* Invoices - Commented out as requested */}
            {/*
            <div className="subscription-card">
              <div className="subscription-card-header">
                <div className="subscription-card-icon">
                  <Receipt size={20} />
                </div>
                <h3>Invoices</h3>
              </div>
              <p className="subscription-description">
                View all past invoices.
              </p>
              <div className="subscription-actions">
                <button
                  type="button"
                  className="subscription-btn secondary"
                  onClick={onGoToBilling}
                >
                  View invoices
                </button>
              </div>
            </div>
            */}
          </div>
        </section>
      </div>
    </div>
  );
};

export default PlanManagementView;
